/**
 * Service: passesSeries
 */
angular.module('acme.common.service.passesSeries', [
  'angularUUID2'
])
.service('PassesSeriesService', ['uuid2', function(uuid2) {

    return {

      model: [],
      generated: [],

      series: {
        _id: '',
        title: '',
        segments: []
      },

      segment: {
        _id: '',
        type: '',
        value: '',
        startSequence: '',
        endSequence: ''
      },

      segmentTypes: [
        {
          type: 'uniqueIdentifier',
          label: 'Unique Identifier',
          shortLabel: 'unique'
        },
        {
          type: 'fixedString',
          label: 'Fixed String',
          shortLabel: 'fixed'
        },
        {
          type: 'ascendingRange',
          label: 'Ascending Range',
          shortLabel: 'ascending'
        },
        {
          type: 'descendingRange',
          label: 'Descending Range',
          shortLabel: 'descending'
        }
      ],

      init: function() {
        return true;
      },

      resetModel: function() {
        this.model = [];
        this.series = {
          _id: '',
          title: '',
          segments: []
        };
      },

      getSegmentTypes: function() {
        return angular.copy(this.segmentTypes);
      },

      isValueSegmentType: function(type) {

        var r;

        switch(type) {
          case 'fixedString':
          /* falls through */
          case 'uniqueIdentifier':
            r = true;
            break;
          default:
            r = false;
        }

        return r;

      },

      isRangeSegmentType: function(type) {

        var r;

        switch(type) {
          case 'ascendingRange':
          /* falls through */
          case 'descendingRange':
            r = true;
            break;
          default:
            r = false;
        }

        return r;

      },

      findSegmentType: function(type) {

        var i, ii,
            r = false;

        for (i=0,ii=this.segmentTypes.length;i<ii;i++) {
          if (this.segmentTypes[i].type === type) {
            r = {
              segmentType: this.segmentTypes[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      findSeries: function(id) {

        var i, ii,
            r = false;

        console.log(this.model, id);
        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i]._id === id) {
            r = {
              series: this.model[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      findSegment: function(segments, id) {

        var i, ii,
            r = false;

        for (i=0,ii=segments.length;i<ii;i++) {
          if (segments[i]._id === id) {
            r = {
              segment: segments[i],
              index: i
            };
            break;
          }
        }

        return r;

      },


      addSeries: function() {
        if (!(this.model instanceof Array)) {
          this.model = [];
        }
        this.model.push(this.createSeries());
      },

      createSeries: function() {

        var series = angular.copy(this.series);

        series._id = uuid2.newuuid();
        this.addSegment(series);

        return angular.copy(series);

      },

      addSegment: function(series) {
        series.segments.push(this.createSegment());
      },

      createSegment: function() {

        var segment = angular.copy(this.segment);

        segment._id = uuid2.newuuid();
        segment.type = this.segmentTypes[0].type;

        return angular.copy(segment);

      },

      addLeadingZeros: function(number, characters) {

        var r = number,
            n = parseInt(number, 10),
            c = parseInt(characters, 10);

        if (!isNaN(n) && !isNaN(c)) {
          r =  (parseFloat("1e"+c, 10) + "" + n).slice(-c);
        }

        return r;

      },

      createRangeSegments: function(start, end, type, characters) {

        var s = parseInt(start, 10),
            e = parseInt(end, 10),
            current = s,
            range = [];

        if (type === 'ascendingRange') {
          while(current <= e) {
            range.push(this.addLeadingZeros(current, characters));
            current++;
          }
        }else if (type === 'descendingRange') {
          while(current >= e) {
            range.push(this.addLeadingZeros(current, characters));
            current--;
          }
        }

        return range;

      },

      joinCodes: function(list, parts) {

        var i, ii,
            j, jj,
            codes = parts.shift(),
            r = [],
            joined = [];

        if (list.length === 0) {
          list = codes;
          codes = parts.shift();
        }

        if (codes) {
          for (i = 0, ii = list.length; i < ii; i++) {
            for (j = 0, jj = codes.length; j < jj; j++) {
              joined.push(list[i] + codes[j]);
            }
          }
          r = this.joinCodes(joined, parts);
        }else {
          r = list;
        }

        return r;
      },

      generate: function() {
        var i, ii,
            j, jj,
            sequence;

        for (i = 0, ii = this.model.length; i < ii; i++) {

          sequence = {
            list: [],
            parts: []
          };

          for (j = 0, jj = this.model[i].segments.length; j < jj; j++) {
            if (this.isValueSegmentType(this.model[i].segments[j].type)) {
              sequence.parts.push([this.model[i].segments[j].value]);
            }else if(this.isRangeSegmentType(this.model[i].segments[j].type)) {
              sequence.parts.push(this.createRangeSegments(
                this.model[i].segments[j].startSequence,
                this.model[i].segments[j].endSequence,
                this.model[i].segments[j].type,
                this.model[i].segments[j].characters
              ));
            }
          }

          this.model[i].generated = this.joinCodes([], sequence.parts);

        }

      },

      prepare: function(model) {
        var i, ii,
            j, jj,
            _model = angular.copy(model);

        if (_model instanceof Array) {
          for (i = 0, ii = _model.length; i < ii; i++) {
            _model[i]._id = null;
            delete _model[i]._id;
            for (j = 0, jj = _model[i].segments.length; j < jj; j++) {
              _model[i].segments[j]._id = null;
              delete _model[i].segments[j]._id;
            }
          }
        }

        return _model;
      },
      
      setModel: function(model) {
        this.model = model;
      },

      getModel: function() {

        return this.prepare(this.model);

      }

    };

}]);